import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'PickupAttendance';

const PickupAttendanceApi: any = baseApi(endpoint);

export default PickupAttendanceApi;